import { childEnvironment } from './environment';

export const getEnvironmentBase = () => ({
  redirectPaths: {
    admin: {
      invitation: '/admin/invitation',
      manage: '/admin/manage/user',
      managePhysicians: `/admin/manage/physician`,
      qrcode: '/admin/qrcode',
    },
    login: '/login',
    noAccess: '/no-access',
    physician: {
      registration: '/physician/registration',
    },
    transfer: {
      previousOfficialAccount: '/transfer/previous-oa',
      registration: '/transfer/registration',
    },
    user: {
      afterLogin: '/user/after-login',
      createOrder: '/user/create-order',
      home: '/user/home',
      hospitalQrcode: '/user/hospital-qrcode',
      invitationQrcode: '/user/invitation-qrcode',
      medicineQrcode: '/user/medicine-qrcode',
      pending: '/user/pending',
      pointMission: '/user/point-mission',
      preference: '/user/preference',
      productDetail: '/user/product-detail/:productId',
      registration: '/user/registration',
      educationAppointment: '/user/education/appointment',
      educationAppointmentForm: '/user/education/appointment/form',
      educationVideoCall: '/user/education/video-call',
      educationRating: '/user/education/rating',
    },
    userAgreement: '/user-agreement',
    programConsentForm: '/program-consent-form',
    educationVideoCall: '/education-video-call',
  },
  api: {
    account: {
      getMyAccount: `${childEnvironment.cloudrun.api}/accounts/me`,
      checkPhoneLinkAvailability: `${childEnvironment.cloudrun.api}/accounts/phone-link-availability`,
      linkAccount: `${childEnvironment.cloudrun.api}/accounts/link`,
      setAgreeTerms: `${childEnvironment.cloudrun.api}/accounts/agree-terms`,
      setFcmToken: `${childEnvironment.cloudrun.api}/accounts/fcm-token`,
    },
    bodyRecord: {
      createDailySport: `${childEnvironment.cloudrun.api}/body-records/daily-sport`,
      createOrUpdateDailyBodyRecord: `${childEnvironment.cloudrun.api}/body-records/body-record`,
      deletedMeal: `${childEnvironment.cloudrun.api}/body-records/meal/:id`,
      getAllBodyRecordsByUserId: `${childEnvironment.cloudrun.api}/body-records/all/users/:userId`,
      getDailyBodyRecordByDate: `${childEnvironment.cloudrun.api}/body-records/body-record/date/:date`,
      getDailyBodyRecordByDateAndUserId: `${childEnvironment.cloudrun.api}/body-records/body-record/date/:date/:userId`,
      getDailyBodyRecord: `${childEnvironment.cloudrun.api}/body-records/body-record`,
      getDailyBodyRecordByUserId: `${childEnvironment.cloudrun.api}/body-records/body-record/users/:userId`,
      getInitialBodyRecord: `${childEnvironment.cloudrun.api}/body-records/initial`,
      getLastWeightRecord: `${childEnvironment.cloudrun.api}/body-records/latest-weight-record`,
      getLatestRecordBeforeToday: `${childEnvironment.cloudrun.api}/body-records/latest-beforeDate/:date`,
      getLatestTwoBodyRecord: `${childEnvironment.cloudrun.api}/body-records/latest-two`,
      getMonthBodyRecord: `${childEnvironment.cloudrun.api}/body-records/monthly-body-record`,
      getMonthBodyRecordByUserId: `${childEnvironment.cloudrun.api}/body-records/monthly-body-record/users/:userId`,
      getNonNullBodyRecord: `${childEnvironment.cloudrun.api}/body-records/non-null-body-record`,
      getNonNullBodyRecordByUserId: `${childEnvironment.cloudrun.api}/body-records/non-null-body-record/users/:userId`,
      getWeightReport: `${childEnvironment.cloudrun.api}/body-records/weight-report`,
      getWeightReportByUserId: `${childEnvironment.cloudrun.api}/body-records/weight-report/users/:userId`,
      imageUpload: `${childEnvironment.cloudrun.api}/body-records/upload-image`,
      shareImageUpload: `${childEnvironment.cloudrun.api}/body-records/share-image`,
    },
    calendarNotification: {
      createCalendarNotification: `${childEnvironment.cloudrun.api}/calendar-notifications`,
      deleteCalendarNotification: `${childEnvironment.cloudrun.api}/calendar-notifications/:id/:userId`,
      getExpiredCalendarNotifications: `${childEnvironment.cloudrun.api}/calendar-notifications/expired`,
      getNextVisitCalendarNotifications: `${childEnvironment.cloudrun.api}/calendar-notifications/next-visit/:userId`,
    },
    city: {
      getAllCities: `${childEnvironment.cloudrun.api}/cities`,
    },
    consentTemplate: {
      getConsentTemplate: `${childEnvironment.cloudrun.api}/consent-template`,
    },
    district: {
      getAllDistricts: `${childEnvironment.cloudrun.api}/districts`,
    },
    education: {
      getUserEducationAppointment: `${childEnvironment.cloudrun.api}/education-appointment/user-education-appointment`,
      getEducationAppointment: `${childEnvironment.cloudrun.api}/education-appointment/:appointmentId`,
      createEducationAppointment: `${childEnvironment.cloudrun.api}/education-appointment`,
      updateEducationAppointment: `${childEnvironment.cloudrun.api}/education-appointment/:appointmentId`,
      deleteEducationAppointment: `${childEnvironment.cloudrun.api}/education-appointment/:appointmentId`,
      // getUnavailableSlots: `${childEnvironment.cloudrun.api}/education-appointment/unavailable-slots/:date`,
      getAvailableSlots: `${childEnvironment.cloudrun.api}/education-appointment/available-slots/:date/:durationUnit/:userId`,
      getVideoCallAuth: `${childEnvironment.cloudrun.api}/education-video-call/auth`,
      updateVideoCallRecordJoinEndedAt: `${childEnvironment.cloudrun.api}/education-video-call/joinEndedAt/:videoCallRecordId`,
      createEducationRecord: `${childEnvironment.cloudrun.api}/education-record`,
      createVideoCallRecord: `${childEnvironment.cloudrun.api}/education-video-call/create-video-call-record`,
      sessionCloseBeacon: `${childEnvironment.cloudrun.api}/session-close-beacon`,
      updateEducationRecordForm: `${childEnvironment.cloudrun.api}/education-record-form/:id`,
      getEducationRating: `${childEnvironment.cloudrun.api}/education-rating/:educationRatingId`,
      saveEducationRating: `${childEnvironment.cloudrun.api}/education-rating`,
      getLatestUnratedEducationRatingId: `${childEnvironment.cloudrun.api}/education-rating/get-latest-unrated-education-rating-id`,
      sendEducationRatingNotification: `${childEnvironment.cloudrun.api}/rating/send-education-rating-notification`,
    },
    external: {
      authenticate: `${childEnvironment.cloudrun.api}/external/authenticate`,
      profile: `${childEnvironment.cloudrun.api}/external/profile`,
      appointments: `${childEnvironment.cloudrun.api}/external/appointments`,
      logout: `${childEnvironment.cloudrun.api}/external/logout`,
    },
    videoCallExternal: {
      parseToken: `${childEnvironment.cloudrun.api}/video-call-external/video-call-token`,
      auth: `${childEnvironment.cloudrun.api}/video-call-external/auth`,
      createVideoCallRecord: `${childEnvironment.cloudrun.api}/video-call-external/create-video-call-record`,
      updateJoinEndedAt: `${childEnvironment.cloudrun.api}/video-call-external/joinEndedAt`,
      sessionCloseBeacon: `${childEnvironment.cloudrun.api}/video-call-external/session-close-beacon`,
    },
    emailVerification: {
      verifyRoleByEmail: `${childEnvironment.cloudrun.api}/email-verifications/:code`,
    },
    employee: {
      getAllEmployees: `${childEnvironment.cloudrun.api}/employees`,
      registerEmployee: `${childEnvironment.cloudrun.api}/employees/register`,
    },
    employeeInvitation: {
      createPhysicianInvitation: `${childEnvironment.cloudrun.api}/employee-invitations`,
      getPhysicianInvitation: `${childEnvironment.cloudrun.api}/employee-invitations/:code`,
    },
    food: {
      getFoods: `${childEnvironment.cloudrun.api}/foods`,
      foodCategoryCalculate: `${childEnvironment.cloudrun.aiApi}/food_category_calculate`,
    },
    hospital: {
      getAllHospitals: `${childEnvironment.cloudrun.api}/hospitals`,
      getBoundHospitals: `${childEnvironment.cloudrun.api}/hospitals/bound`,
      getHospital: `${childEnvironment.cloudrun.api}/hospitals/:id`,
    },
    hospitalAdminCodeForProgram: {
      getHospitalAdminCodeForProgram: `${childEnvironment.cloudrun.api}/hospital-admin/hospital-admin-code-for-program`,
    },
    login: {
      firebaseCustomToken: `${childEnvironment.cloudrun.api}/login/firebase-custom-token`,
      loginLiff: `${childEnvironment.cloudrun.api}/login/liff`,
      loginLine: `${childEnvironment.cloudrun.api}/login/line`,
      loginPhone: `${childEnvironment.cloudrun.api}/login/phone`,
      phoneStatus: `${childEnvironment.cloudrun.api}/login/phone-status`,
    },
    medicine: {
      getBoundMedicines: `${childEnvironment.cloudrun.api}/medicines/bound`,
      getBoundMedicinesByUserId: `${childEnvironment.cloudrun.api}/medicines/bound/users/:userId`,
      getMedicineByIds: `${childEnvironment.cloudrun.api}/medicines/multiple`,
      getMedicines: `${childEnvironment.cloudrun.api}/medicines`,
    },
    mission: {
      finishMission: `${childEnvironment.cloudrun.api}/users/finish-mission`,
      getMissions: `${childEnvironment.cloudrun.api}/users/missions`,
      getTodayMissions: `${childEnvironment.cloudrun.api}/users/today-missions`,
    },
    order: {
      checkOrder: `${childEnvironment.cloudrun.api}/orders/check`,
      createOrder: `${childEnvironment.cloudrun.api}/orders`,
    },
    personalSetting: {
      getPersonalSetting: `${childEnvironment.cloudrun.api}/personal-setting`,
      updatePersonalSetting: `${childEnvironment.cloudrun.api}/personal-setting`,
    },
    phoneVerification: {
      sendVerificationCode: `${childEnvironment.cloudrun.api}/phone-verifications/send-verification-code`,
      verifyPhone: `${childEnvironment.cloudrun.api}/phone-verifications/verify-phone`,
    },
    physician: {
      acceptPhysicianToPhysicianGroup: `${childEnvironment.cloudrun.api}/physicians/bound/accept`,
      deletePhysicianGroupBoundToPhysician: `${childEnvironment.cloudrun.api}/physicians/:physicianId/bound/hospitals/:hospitalId`,
      getAllHospitalStaff: `${childEnvironment.cloudrun.api}/physicians/staff`,
      getPhysicianGroupToPhysicianViewModelByPhysicianId: `${childEnvironment.cloudrun.api}/physicians/:physicianId/bound/physician-groups`,
      getPhysicianLineUserProfile: `${childEnvironment.cloudrun.api}/physicians/:physicianId/line-user`,
      getPhysiciansWithGroupAndHospital: `${childEnvironment.cloudrun.api}/physicians`,
      registerPhysician: `${childEnvironment.cloudrun.api}/physicians/register`,
      rejectPhysicianJoinPhysicianGroup: `${childEnvironment.cloudrun.api}/physicians/bound/reject`,
      updatePhysicianGroupBoundToPhysician: `${childEnvironment.cloudrun.api}/physicians/:physicianId/bound`,
      updatePhysicianGroupStatusToEditing: `${childEnvironment.cloudrun.api}/physicians/:physicianId/bound/physician-groups/:physicianGroupId`,
    },
    physicianGroup: {
      countPhysicians: `${childEnvironment.cloudrun.api}/physician-groups/:physicianGroupId/count/physicians`,
      disablePhysicianGroups: `${childEnvironment.cloudrun.api}/physician-groups/:physicianGroupId`,
      getBoundPhysicianGroups: `${childEnvironment.cloudrun.api}/physician-groups/bound`,
      getMainPhysicianExistenceMap: `${childEnvironment.cloudrun.api}/physician-groups/main-physician-existence-map`,
      getPhysicianGroupById: `${childEnvironment.cloudrun.api}/physician-groups/:physicianGroupId`,
      getPhysicianGroups: `${childEnvironment.cloudrun.api}/physician-groups`,
      getPhysicianGroupByUserId: `${childEnvironment.cloudrun.api}/physician-groups/users/:userId`,
      getPhysicianGroupToPhysician: `${childEnvironment.cloudrun.api}/physician-groups/physician`,
      getPhysicianGroupToUserViewModelsByPhysicianGroupId: `${childEnvironment.cloudrun.api}/physician-groups/:physicianGroupId/bound/users`,
      hasPhysicianGroupName: `${childEnvironment.cloudrun.api}/physician-groups/exist/name`,
      hasUser: `${childEnvironment.cloudrun.api}/physician-groups/:physicianGroupId/exist/user`,
      updatePhysicianGroupToUser: `${childEnvironment.cloudrun.api}/physician-groups/bound/users`,
    },
    physicianInvitation: {
      createPhysicianInvitation: `${childEnvironment.cloudrun.api}/physician-invitations`,
      getPhysicianInvitation: `${childEnvironment.cloudrun.api}/physician-invitations/:code`,
    },
    physicianInvitationForProgram: {
      createPhysicianInvitationForProgram: `${childEnvironment.cloudrun.api}/physician-invitation-for-program`,
      getPhysicianInvitationForProgram: `${childEnvironment.cloudrun.api}/physician-invitation-for-program/:code`,
      checkRejected: `${childEnvironment.cloudrun.api}/physician-invitation-for-program/check-rejected`,
    },
    program: {
      getProgramConfig: `${childEnvironment.cloudrun.api}/program/config/:programId`,
      createProgramConsentForm: `${childEnvironment.cloudrun.api}/program/consent-form`,
      downloadProgramConsentForm: `${childEnvironment.cloudrun.api}/program/consent-form/download`,
      getInviterStatus: `${childEnvironment.cloudrun.api}/program/get-inviter-status`,
      getIsUserVerified: `${childEnvironment.cloudrun.api}/program/is-verified-user/:programId`,
    },
    physicianJobTitle: {
      getPhysicianJobTitles: `${childEnvironment.cloudrun.api}/physician-job-titles`,
    },
    pointRecord: {
      getPointRecords: `${childEnvironment.cloudrun.api}/users/point-records`,
      receivePoint: `${childEnvironment.cloudrun.api}/users/receive-special-mission-point`,
    },
    preference: {
      setPreference: `${childEnvironment.cloudrun.api}/preferences`,
      setUsersLabels: `${childEnvironment.cloudrun.api}/users/labels`,
    },
    product: {
      getAllProductsForUser: `${childEnvironment.cloudrun.api}/products/for-user`,
      getProductForUser: `${childEnvironment.cloudrun.api}/products/:productId/for-user`,
    },
    sport: {
      getSports: `${childEnvironment.cloudrun.api}/sports`,
    },
    treatmentProgress: {
      getTreatmentProgress: `${childEnvironment.cloudrun.api}/treatment-progress`,
      getTreatmentProgressPermissions: `${childEnvironment.cloudrun.api}/treatment-progress/permissions`,
    },
    unplannedHospital: {
      requestUnplannedHospital: `${childEnvironment.cloudrun.api}/unplanned-hospitals`,
      getAllUnplannedHospitals: `${childEnvironment.cloudrun.api}/unplanned-hospitals`,
    },
    user: {
      acceptUserJoinPhysicianGroup: `${childEnvironment.cloudrun.api}/users/accept-user-join-physician-group`,
      enableMusic: `${childEnvironment.cloudrun.api}/users/me/music`,
      exitPlan: `${childEnvironment.cloudrun.api}/users/exit`,
      getAfterLoginStatus: `${childEnvironment.cloudrun.api}/users/after-login-status`,
      getExitPlan: `${childEnvironment.cloudrun.api}/users/exit`,
      getUserByUserId: `${childEnvironment.cloudrun.api}/users/:userId`,
      getUsersAndPhysicianGroupIdByPhysicianId: `${childEnvironment.cloudrun.api}/users/users-and-physician-groups-by-physician-id`,
      getUserBoundMedicines: `${childEnvironment.cloudrun.api}/users/physician-groups/:physicianGroupId/users/:userId/medicines`,
      registerUserByInvitationQrcode: `${childEnvironment.cloudrun.api}/users/register/invitation-qrcode`,
      registerUser: `${childEnvironment.cloudrun.api}/users/register`,
      rejectUserJoinPhysicianGroup: `${childEnvironment.cloudrun.api}/users/reject-user-join-physician-group`,
      resetRegistration: `${childEnvironment.cloudrun.api}/users/reset-registration`,
      setHideDailyMissionDialogAt: `${childEnvironment.cloudrun.api}/users/hide-daily-mission-dialog-at`,
      setPicture: `${childEnvironment.cloudrun.api}/users/me/picture`,
    },
    userInvitation: {
      createUserInvitation: `${childEnvironment.cloudrun.api}/user-invitations`,
      getUserInvitation: `${childEnvironment.cloudrun.api}/user-invitations/:code`,
    },
    userInvitationForProgram: {
      createUserInvitationForProgram: `${childEnvironment.cloudrun.api}/user-invitation-for-program`,
      getUserInvitationForProgram: `${childEnvironment.cloudrun.api}/user-invitation-for-program/:code`,
    },
    userTransfer: {
      register: `${childEnvironment.cloudrun.api}/user-transfer/register`,
      transfer: `${childEnvironment.cloudrun.api}/user-transfer`,
      verify: `${childEnvironment.cloudrun.api}/user-transfer/verify`,
    },
    zoom: {
      getSDKToken: `${childEnvironment.cloudrun.api}/zoom/sdk-token`,
      createMeeting: `${childEnvironment.cloudrun.api}/zoom/create-meeting`,
      getMeeting: `${childEnvironment.cloudrun.api}/zoom/meeting/:meetingId`,
      healthCheck: `${childEnvironment.cloudrun.api}/health`,
    },
  },
  site: 'obesityCarePsp',
});
